export const rewardPointsRate = 40;
